import React, { useState } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faChartLine,
    faWrench,
    faThermometerHalf,
    faElevator,
    faBuilding,
    faDoorOpen,
    faLightbulb,
    faBug,
    faPaintBrush,
    faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';
import BuildingMaintenanceDashboard from './BuildingMaintenanceDashboard/BuildingMaintenanceDashboard';
import PlumbingSystems from './PlumbingSystems/PlumbingSystems';
import HeatingCooling from './HeatingCooling/HeatingCooling';
import LiftMaintenance from './LiftMaintenance/LiftMaintenance';
import RoofMaintenance from './RoofMaintenance/RoofMaintenance';
import FacadeMaintenance from './FacadeMaintenance/FacadeMaintenance';
import DoorsWindows from './DoorsWindows/DoorsWindows';
import LightingElectrical from './LightingElectrical/LightingElectrical';
import PestControl from './PestControl/PestControl';
import PaintingRepairs from './PaintingRepairs/PaintingRepairs';
import DefectsReporting from './DefectsReporting/DefectsReporting';
import ComingSoonModal from '../../pages/ComingSoon/ComingSoonModal';
import './BuildingMaintenance.css';

const SHOWCASE_MODE = false;
const COMING_SOON_SECTIONS = [
  'plumbing', 'heating-cooling', 'lift', 'roof', 'facade',
  'doors-windows', 'lighting', 'pest-control', 'painting', 'defects'
];

const sidebarSections = [
  { id: 'dashboard',      title: 'Dashboard',            icon: faChartLine,            component: BuildingMaintenanceDashboard },
  { id: 'plumbing',       title: 'Plumbing Systems',     icon: faWrench,               component: PlumbingSystems },
  { id: 'heating-cooling',title: 'Heating & Cooling',    icon: faThermometerHalf,      component: HeatingCooling },
  { id: 'lift',           title: 'Lift Maintenance',     icon: faElevator,             component: LiftMaintenance },
  { id: 'roof',           title: 'Roof Maintenance',     icon: faBuilding,             component: RoofMaintenance },
  { id: 'facade',         title: 'Facade Maintenance',   icon: faBuilding,             component: FacadeMaintenance },
  { id: 'doors-windows',  title: 'Doors & Windows',      icon: faDoorOpen,             component: DoorsWindows },
  { id: 'lighting',       title: 'Lighting & Electrical',icon: faLightbulb,            component: LightingElectrical },
  { id: 'pest-control',   title: 'Pest Control',         icon: faBug,                  component: PestControl },
  { id: 'painting',       title: 'Painting & Repairs',   icon: faPaintBrush,           component: PaintingRepairs },
  { id: 'defects',        title: 'Defects Reporting',    icon: faExclamationTriangle,  component: DefectsReporting },
];

const SUB_NAV_ITEMS = sidebarSections.map(s => ({
  id: s.id,
  label: s.title,
  icon: <FontAwesomeIcon icon={s.icon} />
}));

const BuildingMaintenance = () => {
  const { id } = useParams();
  const [showComingSoonModal, setShowComingSoonModal] = useState(false);
  const [comingSoonFeatureName, setComingSoonFeatureName] = useState('');

  const ctx = useOutletContext() || {};
  const activeSubSection = ctx.activeSubSection || 'dashboard';
  const setActiveSubSection = ctx.setActiveSubSection || (() => {});

  const handleSectionClick = (section) => {
    if (SHOWCASE_MODE && COMING_SOON_SECTIONS.includes(section)) {
      const sectionData = sidebarSections.find(s => s.id === section);
      setComingSoonFeatureName(sectionData ? sectionData.title : 'This Feature');
      setShowComingSoonModal(true);
      return;
    }
    setActiveSubSection(section);
  };

  const renderContent = () => {
    const section = sidebarSections.find(s => s.id === activeSubSection);
    if (!section?.component) {
      const C = sidebarSections[0].component;
      return <C propertyId={id} onNavigate={handleSectionClick} />;
    }
    if (activeSubSection === 'dashboard') {
      const Component = section.component;
      return <Component propertyId={id} onNavigate={handleSectionClick} />;
    }
    const Component = section.component;
    return <Component propertyId={id} />;
  };

  const visiblePills = activeSubSection === 'dashboard'
    ? SUB_NAV_ITEMS.filter(i => i.id === 'dashboard')
    : SUB_NAV_ITEMS;

  const pillNav = (
    <nav className="rs-subnav">
      {visiblePills.map((item) => (
        <button
          key={item.id}
          className={`rs-pill${activeSubSection === item.id ? ' rs-pill-active' : ''}`}
          onClick={() => handleSectionClick(item.id)}
        >
          {item.icon}
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );

  return (
    <div className="building-maintenance-container">
      <div className="rs-subnav-mobile-wrap">{pillNav}</div>
      <div className="building-maintenance-content">
        <div className="building-maintenance-main">
          <div className="rs-subnav-desktop-wrap">{pillNav}</div>
          {renderContent()}
        </div>
      </div>
      <ComingSoonModal
        isOpen={showComingSoonModal}
        onClose={() => setShowComingSoonModal(false)}
        featureName={comingSoonFeatureName}
      />
    </div>
  );
};

export default BuildingMaintenance;
